/*
  State
*/
const state = {
  charactersData: null,
  characterPos: 0,
  tmpPlayer: null,
  player: null,
};

/*
  Getters
*/
const getters = {
  getCharactersData: state => state.charactersData,
  getCharacterPos: state => state.characterPos,
  getTmpPlayer: state => state.tmpPlayer,
  getPlayer: state => state.player,
};

/*
  Actions
*/
const actions = {

};

/*
  Mutations
*/
const mutations = {
  setCharactersData(state, payload) {
    state.charactersData = payload;
  },
  setCharactersPos(state, payload) {
    state.characterPos = payload;
  },
  setTmpPlayer(state, payload) {
    state.tmpPlayer = payload;
  },
  setPlayer(state, payload) {
    state.player = payload;
  },
};


module.exports = {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/player.js